/* eslint-disable no-unused-vars */

import { makeStyles } from "@mui/styles";

import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ContactsRoundedIcon from "@mui/icons-material/ContactsRounded";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import PaymentIcon from "@mui/icons-material/Payment";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SettingsIcon from "@mui/icons-material/Settings";
import SettingsApplicationsOutlinedIcon from "@mui/icons-material/SettingsApplicationsOutlined";
import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Card from "../../components/Card/Card.js";
import CardFooter from "../../components/Card/CardFooter.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardIcon from "../../components/Card/CardIcon.js";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import API from "../../utils/API";

import { Grid } from "@mui/material"; // core components
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles);

export default function Dashboard(props) {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [payable, setPayable] = useState();
  const [receivable, setReceivable] = useState();

  useEffect(() => {
    loadDataFromServer();
  }, []);

  async function loadDataFromServer() {
    try {
      const { data } = await API.post("/report/analytics", {
        template: "reports/analytics/dashboard/pendingCheque",
      });
      setPayable(data.payables == "" ? 0 : data.payables[0].count);
      setReceivable(data.receivables == "" ? 0 : data.receivables[0].count);
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <div>
      <Grid container spacing={"5px"} style={{ marginTop: "10px" }}>
        {props.context.privileges.accounting_sub_menu_journal_entries && (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <AccountBalanceWalletIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("Journal Entries")}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <PlaylistAddIcon />
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => props.resetView(2)}
                  >
                    {translate("Manage Journal Records")}
                  </a>
                </div>
              </CardFooter>
            </Card>
          </Grid>
        )}
        {props.context.privileges
          .accounting_sub_menu_general_payment_voucher && (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <PaymentIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("General Payment Voucher")}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <PlaylistAddIcon />
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => props.resetView(4)}
                  >
                    {translate("Manage Payments")}
                  </a>
                </div>
              </CardFooter>
            </Card>
          </Grid>
        )}
        {props.context.privileges
          .accounting_sub_menu_general_receipt_voucher && (
          <Grid item xs={12} sm={6} md={4}>
            <Card style={{ marginRight: "30px" }}>
              <CardHeader color="danger" stats icon>
                <CardIcon color="danger">
                  <ReceiptIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("General Receipt Voucher")}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <PlaylistAddIcon />
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => props.resetView(3)}
                  >
                    {translate("Manage Receipts")}
                  </a>
                </div>
              </CardFooter>
            </Card>
          </Grid>
        )}
        {props.context.privileges
          .accounting_sub_menu_inter_account_transactions && (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <AccountBalanceWalletIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("Inter Account Transactions")}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <SettingsApplicationsOutlinedIcon />
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => props.resetView(8)}
                  >
                    {translate("Inter Account Transactions")}
                  </a>
                </div>
              </CardFooter>
            </Card>
          </Grid>
        )}
        {props.context.privileges.accounting_sub_menu_customer_receipt && (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <ContactsRoundedIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("Customer Receipt")}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <PlaylistAddIcon />
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => props.resetView(7)}
                  >
                    {translate("Customer Transactions")}
                  </a>
                </div>
              </CardFooter>
            </Card>
          </Grid>
        )}
        {props.context.privileges.accounting_sub_menu_vendor_payment && (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <LocalShippingRoundedIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("Vendor Payment")}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <PlaylistAddIcon />
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => props.resetView(6)}
                  >
                    {translate("Vendor Transactions")}
                  </a>
                </div>
              </CardFooter>
            </Card>
          </Grid>
        )}
        {props.context.privileges.accounting_sub_menu_chart_of_accounts && (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <SettingsIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("Chart of Accounts")}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <SettingsApplicationsOutlinedIcon />
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => props.resetView(5)}
                  >
                    {translate("Accounts Settings")}
                  </a>
                </div>
              </CardFooter>
            </Card>
          </Grid>
        )}
        {props.context.privileges.accounting_sub_menu_bank_reconciliation && (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <RequestQuoteIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("Bank Reconciliation")}
                </p>
                <p className={classes.paragraph}>
                  {translate("Payables : ")}
                  {payable}
                </p>
                <p className={classes.paragraph}>
                  {translate("Receivables : ")}
                  {receivable}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <RequestQuoteIcon />
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => props.resetView(9)}
                  >
                    {translate("Pending Cheque List")}
                  </a>
                </div>
              </CardFooter>
            </Card>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
